import { BaseQueryFn } from "@reduxjs/toolkit/query";
import axios, { AxiosRequestConfig, AxiosError } from "axios";
import { tokenUtil, growlSuccess, userManagementUtil } from "@siba/utilities";
import { ShowInfoNotification, ShowErrorNotification, ShowWarningNotification, ShowSuccessNotification, toggleloading, sibaStore } from "@siba/components";
// definition for headers that is constant for each request.
const headers: Record<string, string> = {
    "Access-Control-Allow-Origin": `*`,
    accept: "text/plain",
    "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE",
    authorization: `Bearer ${tokenUtil.getToken()}`,
    "Content-Type": "application/json",
    "X-OTAG": tokenUtil.getDecodedToken()["Organization"]
};

// will handle ajax requests and is defined for one url,
/**
 *
 * @param url string
 * @param method ajax method of (post | get | put | etc)
 * @data data being sent with the request.
 * @returns result object with property data containing the ajax response.
 */
const axiosBaseQuery =
    ({
        baseUrl
    }: {
        baseUrl: string;
    }): BaseQueryFn<
        {
            url: string;
            method: AxiosRequestConfig["method"];
            data?: AxiosRequestConfig["data"];
        },
        unknown,
        unknown
    > =>
    async ({ url, method, data }) => {
        try {
            // set loading state to true.
            sibaStore.dispatch(toggleloading({ value: true }));

            // get ajax result;
            const result = await axios({
                url: baseUrl + url,
                method,
                data,
                headers
            });

            // turn off global loading state.
            sibaStore.dispatch(toggleloading({ value: false }));

            if (result.data?.errors) {
                ShowErrorNotification(result.data.message.toString() as string);
                return { data: {} };
            }
            //handle success indication.
            else if (result.data?.state) {
                const message = result.data.message as string;

                //growlSuccess(message);
                try {
                    if (message && message.toLocaleLowerCase() != "success") growlSuccess(message);
                } catch {
                    if (message && message.toLocaleLowerCase() != "success") ShowSuccessNotification(message);
                }
            } else {
                switch (result.data?.type) {
                    case 2: // error
                        {
                            ShowErrorNotification(result.data.message.toString());
                        }
                        break;
                    case 1: // warning
                        {
                            ShowWarningNotification(result.data.message.toString() as string);
                        }
                        break;
                    case 0: // info
                        {
                            ShowInfoNotification(result.data.message.toString() as string);
                        }
                        break;
                    default:
                        {
                            ShowErrorNotification(result.data.message.toString() as string);
                        }
                        break;
                }

                return { data: {} };
            }

            //return ajax result.
            return { data: result.data?.data };
        } catch (axiosError) {
            // handle request errors.
            let err = axiosError as AxiosError;

            //set loading state to false.
            sibaStore.dispatch(toggleloading({ value: false }));
            // return error details.
            ShowErrorNotification((err.response?.status ? err.response?.status : "") + (err.response?.statusText ? " " + err.response?.statusText + " " + err.message : "   Request was Unsuccessful"));
            return {
                error: { status: err.response?.status, data: err.response?.data }
            };
        }
    };

export default axiosBaseQuery;
